import type { TAction } from '../../src/stores/activity'
import { Base_Dispatcher } from '../Base/Base.Dispatcher'

export function Acti_dispatch(data: TAction) {
    Base_Dispatcher.dispatch(data)
}
